import dateFormat from 'dateformat';
import { DATE_FORMAT_DMY, CURRENCY_INFO, BCA_STATUS_LIST,IS_EMP_APP,IS_FAVORITE_APP,IS_OTO_APP,IS_TRIIVCO_APP, GET_ROLE_ID_BY_TYPE,TAB_ORDER} from "../../config/constant";
import secureStorage from "./../../config/encrypt";
import store from '../../store/store';
import { getLocalBankList } from '../../utils/bank/bank-util';
import * as XLSX from "xlsx";
import { setFrontendConfig } from '../../store/allAction';
import PaymentService from "../../service/paymentService";

import { useNavigate,useParams,useLocation } from 'react-router-dom';

let currencyInfo = secureStorage.getItem("currencyInfo") || CURRENCY_INFO;
let LS_CONVERSION_RATE = currencyInfo && currencyInfo.CONVERSION_RATE ? currencyInfo.CONVERSION_RATE : 1;

export const localeNumber = (str) => {
    let term = ','
    let replacement = '.';
    return str.toLocaleString().replace(RegExp(term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), 'g'), replacement);
};

export const strToNumber = (str) => {
    str = str.toString();
    let amount = +(str && str.replaceAll('.', '').replace(',', '.')) || 0;
    return +(amount && amount.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]) || 0;
};

export const numberFormatWithDots = (str) => {
    if(str){
        str = str.toString().split('.');
        let thousandsGroupRegex = /(\d)(?=(\d{3})+(?!\d))/g;
        let index = str[0].search(/[1-9]/);
        index = index === -1 ? str[0].length : index;
        return (
            str[0].substring(0, index) +
            str[0].substring(index, str[0].length).replace(thousandsGroupRegex, "$1.") +
            (str[1] !== undefined ? ',' + str[1].substring(0, 2) : '')
        );
    }
    else{
        return 0;
    }
};

export const inputNumberFormat = (str) => {
    if (typeof str === 'number') str = str.toString().split('.');
    else str = str.split(',');
    let thousandsGroupRegex = /(\d)(?=(\d{3})+(?!\d))/g;
    let firstString = str[0].replace(/\D/g, '')
    let index = firstString.search(/[1-9]/);
    index = index === -1 ? firstString.length : index;
    return (
        firstString.substring(0, index) +
        firstString.substring(index, firstString.length).replace(thousandsGroupRegex, "$1.") +
        (str[1] !== undefined ? ',' + str[1].substring(0, 2) : '')
    );
};

export const numberFormatWithCurrency = (num, change = 'YES') => {
    let { currency } = store.getState();
    let CONVERSION_RATE = currency.CONVERSION_RATE || LS_CONVERSION_RATE;
    if (Object.keys(currency).length !== 0 && (currency.PARENT_CURRENCY === currency.CURRENT_CURRENCY)) CONVERSION_RATE = 1;
    num = num * CONVERSION_RATE;
    return change == 'YES' ? numberFormatWithDots(num) : num;
};
export const displayDate = (d,format=DATE_FORMAT_DMY) => {
    return d ? dateFormat(d, format) : ""
}
export const uniqueArr = (arrayOfObj, key) => {
    return arrayOfObj.filter((item, index, array) => {
        //return array.map((mapItem) => mapItem[key]).indexOf(item[key]) === index
        return array.map((mapItem) => mapItem[key] === item[key] && mapItem.lead_source === item.lead_source)
    })
}
export const displayTAT = (created_date, approved_date) => {
    if (created_date == '' || approved_date == '') {
        return 'NA'
    }
    else {
        const diffDateTime = new Date(created_date) - new Date(approved_date);
        let diff = Math.abs(diffDateTime);
        let ms = diff % 1000;
        diff = (diff - ms) / 1000;
        let ss = diff % 60;
        diff = (diff - ss) / 60;
        let mm = diff % 60;
        diff = (diff - mm) / 60;
        let hh = diff % 24;
        let days = (diff - hh) / 24;
        return (days*24)+hh + ':' + mm + ':' + ss;
    }
}
export const displayChar = (str,limit=20) => {
    return str && str.length>limit ? str.substring(0,limit)+'...': str;
}
export const numberFormatWithLocale = (number, amount_format_type = 'en') => {
    let flt = number % 1 === 0 ? ',00' : '';
    return amount_format_type === 'id' ? `${number.toLocaleString('id-ID')}${flt}` : `${number.toLocaleString('en-IN')}`;
}
export const RECONCILATION_STATUS =(status)=>{
    let statusObj = {'matched': 'Matched','not_matched' : 'Not Matched','duplicate' : 'Duplicate','matched_duplicate':'Matched Duplicate','matched_manually':'Matched Manually', "bulk_matched": "Bulk Matched"}
    return statusObj[status]
}
export const DISPLAY_PAYMENT_TYPE = (state,source='finance')=>{
    let obj = {"main_dealer": source=='finance' ? "Dealer Payment" : "Dealer/Agent Incentive","split_dealer": "Split Payment","split_dealer2": "Split Payment2","agent_fee": "Agent Fee","referral_agent": "Referral Agent","agent_incentive": "Agent Incentive","onhold_dealer": "Onhold Dealer Payment", "onhold_agent": "Onhold Agent Payment" };
    return obj[state] || '';
}
export const displayBank = (bank_name)=>{
    const ENTITY_BANK_LIST = getLocalBankList();
    let bank = '';
    if(bank_name!=""){
        const existingBank = ENTITY_BANK_LIST && ENTITY_BANK_LIST?.length > 0
            ? ENTITY_BANK_LIST.find((eBank) => +eBank.id === +bank_name)
            : {};

        if (existingBank && Object.keys(existingBank).length > -1) {
            bank = existingBank.bank_name + '-' + existingBank.account_number;
        }
    }
    return bank;
}

export const getBCAStatus = (paymentSource, paymentStatus, userType) => {
    if (userType !== 'agent') {
        return BCA_STATUS_LIST.find((status) => status.is_elegible_for.includes('other') && status.value === 'OTHER')?.label || '-';
    } else {
        return BCA_STATUS_LIST.find((status) => status.is_elegible_for.includes('agent') && status.value === paymentStatus)?.label || '-';
    }
};

export const getLast4Digit = (otoBank) => {
    const ENTITY_BANK_LIST = getLocalBankList();
    const existingBank = ENTITY_BANK_LIST && ENTITY_BANK_LIST?.length > 0
            ? ENTITY_BANK_LIST.find((eBank) => +eBank.id === +otoBank)
            : {};

    if (existingBank && Object.values(existingBank).length > 0) {
        const strAccount = existingBank.account_number.toString(); // Convert number to string
        return strAccount.slice(-4);
    }
    return "";
};

export const getEntityType = () =>{
    let entityName = '';
    entityName = IS_EMP_APP ? 'emp':IS_FAVORITE_APP ? 'fav' : IS_TRIIVCO_APP ? 'triv' : 'oto';
    return entityName;
}


export const getAllocationLabel = (obj, t) => {
  if (obj.allocated_service_lead_ids) {
    return "Service & VAT for NIM Financier";
  }

  if (obj.is_assigned_for_other_transaction === "1") {
    return "Amount Allocated as Other Transaction";
  }

  if (obj.is_assigned_for_revenue === "1") {
    return "Amount Allocated as Additional Revenue";
  }

  if (+obj.is_for_edited === 1) {
    return "Amount allocated on Edited Loan IDs";
  }

  const lostLoanLabel = obj.is_takeover === "1"
    ? t("INBOUND_PAYMENT.PAYMENT_CHARGES_AMOUNT_ALLOCATED_ON_LOST_LOAN_IDS")
    : t("INBOUND_PAYMENT.AMOUNT_ALLOCATED_ON_LOST_LOAN_IDS");

  if (obj.financier_name === "" || obj.is_takeover === "1") {
    return lostLoanLabel;
  }

  return "---";
}

export const formatAmount =(amount, formatType = 'en') => {
  const numericAmount = Number(amount);

  if (isNaN(numericAmount)) return '0';

  switch (formatType) {
    case 'id':
      return `=""${numericAmount.toLocaleString('id-ID')}""`;
    default:
      return numericAmount.toLocaleString('en-IN');
  }
}

export const uploadDocToS3 = async (file) => {
		let toReturn={}
		const formUploadData = new FormData();
		formUploadData.append("upload_type", "pb_docs");
		formUploadData.append("lead_id", new Date().getMilliseconds());
		formUploadData.append("images", file);
	
		const uploadResp = await PaymentService.uploadFilesToS3(formUploadData, {
		  "Content-Type": "multipart/form-data",
		});
	
		if (uploadResp?.data?.status === 200) {
		  toReturn = {
			...toReturn,
			doc_aws_path: uploadResp?.data?.data?.[0]?.file_url,
			file_name:uploadResp?.data?.data?.[0]?.file_name,
			isUploaded: true,
		  };
		} else {
			toReturn = {
				...toReturn,
				doc_aws_path: '',
				file_name:'',
				isUploaded: false,
			  };
		}
		return toReturn;
	  };

export const getMonthOptions = () => {
    const start = new Date(); // current month
    start.setDate(1); // normalize

    const end = new Date(start);
    end.setMonth(end.getMonth() - 12); // 1 year back

    const months = [];
    let current = new Date(start);

    while (current >= end) {
        const value = `${current.getFullYear()}-${String(current.getMonth() + 1).padStart(2, "0")}`;
        const label = current.toLocaleString("default", {
            month: "long",
            year: "numeric"
        });

        months.push({ label, value });
        current.setMonth(current.getMonth() - 1); // move backward
    }

    return months;
};


export const getUserNameById = (id,users) => {
        const user = users?.find(u => String(u.id) === String(id));
        return user ? user?.name : "Unknown User";
    };    

export const CheckDaysPassed = (date,days) => {
    if (!date) return false;

    const requestDate = new Date(date);
    const now = new Date();

    // Calculate the difference in milliseconds
    const diffMs = now - requestDate;

    // Convert  days to milliseconds
    const thirtyDaysMs = days * 24 * 60 * 60 * 1000;

    return diffMs >= thirtyDaysMs;
}
    
/**
 * Extracts year and month from a string in "YYYY-MM" format.
 * @param {string} dateStr - The date string in "YYYY-MM" format.
 * @returns {{ year: number, month: number }} An object with numeric year and month.
 */
export const getYearAndMonth = (dateStr) => {
    if (!dateStr || typeof dateStr !== 'string') {
        throw new Error('Invalid date string');
    }
    
    const [year, month] = dateStr.split('-').map(Number);

    if (isNaN(year) || isNaN(month)) {
        throw new Error('Invalid year or month in date string');
    }

    return { year, month };
}


export const userRoleCheck = (type) => {
    const loggedInUser = secureStorage.getItem("authUserInfo");
    const userDetail = (loggedInUser && loggedInUser.user_data) ? loggedInUser.user_data : {};
    const role_id = userDetail && userDetail.role_id ? userDetail.role_id.split(',').map(item => +item) : [];
    let isUser = false;
    if (type) {
        if (isLoggedInUserRoleValid(role_id, type)) {
            isUser = true;
        }
    }
    return isUser;
}
// This function is used to verify the loggedin user role
export const isLoggedInUserRoleValid = (roleIds, roleType) => {
    let isRoleValid = false;
    let roleIdToVerify = (roleType === 'maker') ? GET_ROLE_ID_BY_TYPE('maker') : (roleType === 'edited_loan_approver') ? GET_ROLE_ID_BY_TYPE('edited_loan_approver') : (roleType === 'approver') ? GET_ROLE_ID_BY_TYPE('approver') : (roleType === 'hrf_approver') ? GET_ROLE_ID_BY_TYPE('hrf_approver') : (roleType === 'hrf_maker') ? GET_ROLE_ID_BY_TYPE('hrf_maker') :''
    isRoleValid = roleIds.includes(roleIdToVerify);
    return isRoleValid;
}


export const downloadSampleXlxsFile = (data,filename)=> { 
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");

  XLSX.writeFile(workbook, filename);
}
// Date  Independent of timezone 
export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getTabConfig = async (dispatch) => {
    try {
        await PaymentService.getConfig({ config_data: ['site_config'] })
            .then((response) => {
                if (response && response.status && response.status === 200) {
                    let responseData = response.data.data;
                    dispatch(setFrontendConfig(responseData.site_config));
                }
            })
            .catch();
    } catch (error) {

    }
};
export function withRouter(Component) {
  return function Wrapper(props) {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    return (
      <Component
        {...props}
        navigate={navigate}
        params={params}
        location={location}
      />
    );
  };
}

export const setEntitySourceBasedOnDomain = () => {
  const domain = window.location.hostname;

  if ([process.env.REACT_APP_DOMAIN_TRIV].includes(domain)) {
    secureStorage.setItem("entitySource", "triv-id");
  } else if ([process.env.REACT_APP_DOMAIN_FAV].includes(domain)) {
    secureStorage.setItem("entitySource", "fav-id");
  } else if ([process.env.REACT_APP_DOMAIN_OTO].includes(domain)) {
    const currentSource = secureStorage.getItem("entitySource");
    if (!["emp-id"].includes(currentSource)) {
      secureStorage.setItem("entitySource", "oto-in");
    }
  }
}

export const isOlderThan24Hours = (time) => {
    if (!time) return true; // if no time, allow button

    const generatedTime = new Date(time);
    const now = new Date();

    const diffInMs = now - generatedTime;
    const diffInHours = diffInMs / (1000 * 60 * 60);
    return diffInHours >= 23; // return true if older than or equal to 23 hours
};
export const isTargetTabValid = (currentTab, targetTab) => {
    const currentIndex = TAB_ORDER.indexOf(currentTab);
    const targetIndex = TAB_ORDER.indexOf(targetTab);
    return (targetIndex <= currentIndex)
};

export const getAllTab = (
    leadSource,
    is_edited_loan
) => {

    const baseTabs = [
        ...(!IS_FAVORITE_APP && leadSource !== 'hrf') ? ["dealer"] : [],
        "customer"
    ];

    const financeTabs = [
        "po",
        "do",
        "refund",
        ...(IS_OTO_APP ? ["fid"] : [])
    ];

    const refinanceTabs = ["car"];
    const hrfTabs = ["property_detail"];
    const commonTabs = ["payment"];

    const editedLoanTab =
        ['finance', 'refinance'].includes(leadSource) && +is_edited_loan === 1
            ? ["edited_loan"]
            : [];

    const finalTabs = [
        ...baseTabs,
        ...(leadSource === 'finance'
            ? financeTabs
            : leadSource === 'hrf'
                ? hrfTabs
                : refinanceTabs),
        ...commonTabs,
        ...editedLoanTab
    ];

    return finalTabs;
};

export const getNextActiveTabName = (
    leadSource,
    is_edited_loan,
    currentTab,
    dbActiveTab //  NEW PARAM (important)
) => {

    const finalTabs = getAllTab(leadSource,is_edited_loan);

    const currentIndex = finalTabs.indexOf(currentTab);
    const dbIndex = finalTabs.indexOf(dbActiveTab);

    if (currentIndex === -1) {
        return finalTabs[0] || null;
    }

    // KEY LOGIC: if DB tab is ahead → jump to DB tab
    if (dbIndex > currentIndex) {
        return dbActiveTab;
    }

    //  Normal forward flow
    if (currentIndex < finalTabs.length - 1) {
        return finalTabs[currentIndex + 1];
    }

    //  Last tab → stay
    return currentTab;
};

export const isCurrentTabSaved = (
    leadSource,
    is_edited_loan,
    currentTab,
    dbActiveTab //  NEW PARAM (important)
) => {

    const finalTabs = getAllTab(leadSource,is_edited_loan);

    const currentIndex = finalTabs.indexOf(currentTab);
    const dbIndex = finalTabs.indexOf(dbActiveTab);

    if (currentIndex === -1) {
        return finalTabs[0] || null;
    }

    // KEY LOGIC: if DB tab is ahead → jump to DB tab
    if (dbIndex > currentIndex) {
        return true;
    }else{
        return false
    }

};

export const getSplitInfo = ({ lead_source, entity_source, details }) => {
    const isRefinance = ['refinance'].includes(lead_source);
    const isBikeRefinance = ['bikerefinance'].includes(lead_source);
    const isHrf = ['hrf'].includes(lead_source);
    const isDynamicBooster = +details?.details?.is_dynamic_booster_enabled === 1;
    const isAgentIncentive = +details?.details?.is_agent_incentive === 1;

    // ---------------- BASE (ALWAYS PRESENT) ----------------
    const base = {
        split_dealer: { title: 'SPLIT_PAYMENT', text: 'PAYMENT_TYPE_SPLIT' },
        split_dealer2: { title: 'SPLIT_PAYMENT2', text: 'PAYMENT_TYPE_SPLIT2' },
        agent_fee: { title: 'AGENT_FEE', text: 'AGENT_FEE' },
        referral_agent: { title: 'REFERRAL_AGENT', text: 'REFERRAL_AGENT' },
        agent_incentive: { title: 'AGENT_INCENTIVE', text: 'AGENT_INCENTIVE' },
        onhold_dealer: { title: 'ONHOLD_DEALER', text: 'ONHOLD_DEALER' },
        dealer_incentive: { title: 'DEALER_INCENTIVE', text: 'DEALER_INCENTIVE' },
        platinum_incentive: { title: 'PLATINUM_INCENTIVE', text: 'PLATINUM_INCENTIVE' },
        bm_fee: { title: 'BM_FEE', text: 'BM_FEE' },
        bro_fee: { title: 'BRO_FEE', text: 'BRO_FEE' },
        onhold_agent: { title: 'ONHOLD_AGENT', text: 'ONHOLD_AGENT' },
        alpha_incentive: { title: 'ALPHA_INCENTIVE', text: 'ALPHA_INCENTIVE' },
        take_over_amount: { title: 'TAKE_OVER_AMOUNT', text: 'TAKE_OVER_AMOUNT' },
        customer_payment: { title: 'CUSTOMER_PAYMENT', text: 'CUSTOMER_PAYMENT' },
        po_refund_adjustment: { title: 'EDIT_LOAN_ADJUSTMENT', text: 'EDIT_LOAN_ADJUSTMENT' },
        dsa_mm_incentive: { title: 'DSA_MM_INCENTIVE', text: 'DSA_MM_INCENTIVE' },
        bm_incentive: { title: 'BM_INCENTIVE', text: 'BM_INCENTIVE' },
        onhold_payment: { title: 'ONHOLD_PAYMENT', text: 'ONHOLD_PAYMENT' },
        on_hold_payment: { title: 'ON_HOLD_PAYMENT', text: 'ON_HOLD_PAYMENT' },
    };

    // ---------------- FINANCE ----------------
    const financeConfig = lead_source === 'finance' ? {
        main_dealer: {
            title: 'DEALER_PAYMENT',
            text: 'PAYMENT_TYPE_MAIN_DEALER'
        },
        agent_dynamic_booster: {
            title: 'AGENT_DYNAMIC_BOOSTER',
            text: 'AGENT_DYNAMIC_BOOSTER'
        }
    } : {};

    // ---------------- TRIV OVERRIDE ----------------
    const trivConfig = entity_source === 'triv' ? {
        agent_dynamic_booster: {
            title: 'TRIV_AGENT_DYNAMIC_BOOSTER',
            text: 'TRIV_AGENT_DYNAMIC_BOOSTER'
        }
    } : {};

    // ---------------- REFINANCE MAIN DEALER ----------------
    let refinanceMainDealer = {};
    if (isRefinance && isDynamicBooster) {
        refinanceMainDealer = {
            main_dealer: isAgentIncentive
                ? { title: 'UCRF_AGENT_DYNAMIC_BOOSTER', text: 'UCRF_AGENT_DYNAMIC_BOOSTER' }
                : { title: 'DEALER_DYNAMIC_BOOSTER', text: 'DEALER_DYNAMIC_BOOSTER' }
        };
    }

    // ---------------- NO BOOSTER ----------------
    const noBoosterConfig =
        (isRefinance || isBikeRefinance) && !isDynamicBooster
            ? {
                main_dealer: {
                    title: 'INCENTIVE_AMOUNT',
                    text: 'PAYMENT_TYPE_TOTAL_INCENTIVE_AMOUNT'
                }
            }
            : {};

    // ---------------- ENTITY BASED ----------------
    const entityConfig = {
        ...(entity_source !== 'emp' && {
            aro_fee: { title: 'ARO_FEE', text: 'ARO_FEE' },
            dsa_incentive: { title: 'DSA_INCENTIVE', text: 'DSA_INCENTIVE' }
        }),
        ...(entity_source === 'emp' && {
            aro_fee: { title: 'KAO_FEE', text: 'KAO_FEE' },
            dsa_incentive: { title: 'MAC_INCENTIVE', text: 'MAC_INCENTIVE' }
        })
    };

    // ---------------- REFINANCE BOOSTERS ----------------
    const refinanceBoosters = isRefinance ? {
        agent_dynamic_booster: { title: 'AGENT_BOOSTER', text: 'AGENT_BOOSTER' },
        aro_dynamic_booster: { title: 'ARO_BOOSTER', text: 'ARO_BOOSTER' },
        bro_dynamic_booster: { title: 'BRO_BOOSTER', text: 'BRO_BOOSTER' },
        fixed_aro_dynamic_booster: { title: 'FIARO_BOOSTER', text: 'FIARO_BOOSTER' },
        dealer_dynamic_booster: { title: 'DEALER_BOOSTER', text: 'DEALER_BOOSTER' }
    } : {};

    // ----------------HRF REFINANCE  ----------------
    const hrfSplit = isHrf ? 
        +details?.sfa_role_id === 52 ? 
        {
            main_dealer: { title: 'BM_INCENTIVE', text: 'BM_INCENTIVE' },
            split_dealer: { title: 'BM_SPLIT_PAYMENT1', text: 'BM_SPLIT_PAYMENT1' },
            split_dealer2: { title: 'BM_SPLIT_PAYMENT2', text: 'BM_SPLIT_PAYMENT2' },
            onhold_agent: { title: 'ONHOLD_BM', text: 'ONHOLD_BM' },
        } :
        {
            main_dealer: { title: "HRF_AGENT_INCENTIVE", text: "HRF_AGENT_INCENTIVE" },
            split_dealer: { title: 'AGENT_SPLIT_PAYMENT1', text: 'AGENT_SPLIT_PAYMENT1' },
            split_dealer2: { title: 'AGENT_SPLIT_PAYMENT2', text: 'AGENT_SPLIT_PAYMENT2' },
            onhold_agent: { title: 'ONHOLD_AGENT', text: 'ONHOLD_AGENT' },
        } : {};

    // ---------------- FINAL MERGE (ORDER MATTERS) ----------------
    return {
        ...base,
        ...financeConfig,
        ...trivConfig,
        ...noBoosterConfig,
        ...refinanceMainDealer,
        ...entityConfig,
        ...refinanceBoosters,
        ...hrfSplit
    };
};
